import * as angular from 'angular';
import {IController} from "angular";
import {OmsOrdersGroupType} from "../../types/omsOrdersGroup.type";

export class OmsOrdersGroupSelectCtrl implements IController {
  group: OmsOrdersGroupType;
  ngPlaceholder: any;
  onChange: Function;

  private options: any;

  /* @ngInject */
  constructor() {
    this.options = OmsOrdersGroupType;
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('omsOrdersGroupSelect', {
    bindings: {
      group: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./oms-orders-group-select.html').default,
    controller: OmsOrdersGroupSelectCtrl
  });
